import React from 'react';
import { AnchorTile } from './types/Anchor';

export default function Anchor({ tile }: { tile: AnchorTile }) {
  const id = tile.id.text || '';
  return <div id={id} />;
}
